module.exports = __webpack_public_path__ + "img/Nokor.c92e78a8.png";